<template>
  <!-- <transition name="fade" mode="out-in"> -->
  <div class="screen-wrap">
    <v-app class="hmc-app">
      <v-main class="main-body">
        <v-container class="app-body">
          <!-- BOC:[error] -->
          <ApiErrorDialog v-if="FinisherApi.isError" :api="FinisherApi" />
          <ErrorDialog v-if="error" :error="error" :message="errorMessage" @exitError="extiError" />
          <!-- EOC -->
          <div class="pe-2 ps-3 app-title text-h5">
            {{ $t("string.finisherGiftTitle") }}
            <v-spacer></v-spacer>
            <CloseBtn size="40" :callback="exit" />
          </div>
          <div class="pa-5">
            <v-img :src="require('@/assets/explore/gift_1.png')" width="300" class="mx-auto"
              style="margin-top: -70px; margin-bottom: -30px"></v-img>
            <div class="text-center mb-4 mx-auto" style="max-width: 250px">
              <div class="text-h6">
                {{ $t("string.finisherGiftMsg4") }}
              </div>
            </div>
            <div class="text-caption mx-1">Full Name as per NRIC or Passport</div>
            <v-text-field v-model="name" solo flat hide-details class="mb-2"></v-text-field>

            <div v-if="auth.Group.type == 'family'">
              <div class="text-caption mx-1">Gender</div>
              <v-select v-model="gender" :items="genders" item-value="value" item-text="name" solo flat hide-details
                class="mb-2" attach></v-select>
              <v-text-field v-if="gender == 'other'" v-model="originalGender" solo flat hide-details
                class="mb-2"></v-text-field>

              <div class="text-caption mx-1">Race</div>
              <v-select v-model="race" :items="races" item-value="value" item-text="name" solo flat hide-details
                class="mb-2" attach></v-select>
              <v-text-field v-if="race == 'other'" v-model="originalRace" solo flat hide-details
                class="mb-2"></v-text-field>

              <div class="text-caption mx-1">NRIC/Passport No.</div>
              <v-text-field v-model="moeNumber" solo flat hide-details class="mb-2"></v-text-field>

              <div class="text-caption mx-1">Email Address (Preferably use your Delima Email if any)</div>
              <v-text-field v-model="email" solo flat hide-details class="mb-2"></v-text-field>
            </div>

            <div class="text-caption mx-1">School</div>
            <v-text-field v-model="school" solo flat hide-details class="mb-2"></v-text-field>

            <div class="text-caption mx-1">Class</div>
            <v-text-field v-model="classroom" solo flat hide-details class="mb-2"></v-text-field>

            <div class="text-caption mx-1">Town</div>
            <v-text-field v-model="town" solo flat hide-details class="mb-2"></v-text-field>

            <div class="text-caption mx-1">State</div>
            <v-select v-model="state" :items="states" item-value="value" item-text="name" solo flat hide-details
              class="mb-2" attach></v-select>

            <div class="text-center mt-6">
              <v-btn class="text-h6" height="34" color="yellow" large width="200" @click="okAction()"
                :loading="FinisherApi.isLoading">
                {{ $t("action.ok") }}
              </v-btn>
            </div>
          </div>
        </v-container>
      </v-main>
    </v-app>
  </div>
  <!-- </transition> -->
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
    ErrorDialog: () =>
      import(
        /* webpackChunkName: "component-error-dialog" */ "@/components/ErrorDialog.vue"
      ),
  },
  computed: mapState({
    auth: (state) => state.auth.data,
    series: (state) => state.series.data,
  }),
  props: [
    //
  ],
  data: () => ({
    name: "",
    classroom: "",
    school: "",
    town: "",
    state: "",
    FinisherApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    FinisherDataApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    StateDataApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    error: false,
    errorMessage: null,
    races: [
      {
        id: 1,
        name: "Not Sure",
        value: null,
      },
      {
        id: 2,
        name: "Chinese",
        value: "chinese",
      },
      {
        id: 3,
        name: "Malay",
        value: "malay",
      },
      {
        id: 4,
        name: "Indian",
        value: "indian",
      },
      {
        id: 5,
        name: "Other",
        value: "other",
      },
    ],
    genders: [
      {
        id: 1,
        name: "Not Sure",
        value: null,
      },
      {
        id: 2,
        name: "Male",
        value: "male",
      },
      {
        id: 3,
        name: "Female",
        value: "female",
      },
      {
        id: 4,
        name: "Other",
        value: "other",
      },
    ],
    gender: null,
    race: null,
    moeNumber: null,
    email: null,
    originalRace: null,
    originalGender: null,
    states: []
  }),
  created() {
    this.FinisherApi.url =
      this.$api.servers.event +
      "/api/v1/" +
      this.$_getLocale() +
      "/game/event/finisher/load";

    this.FinisherApi.callbackReset = () => {
      this.FinisherApi.isLoading = true;
      this.FinisherApi.isError = false;
    };

    this.FinisherApi.callbackError = (e) => {
      this.FinisherApi.isLoading = false;
      this.FinisherApi.isError = true;
      this.FinisherApi.error = e;
    };
    this.FinisherApi.callbackSuccess = (resp) => {
      this.FinisherApi.isLoading = false;
      if (resp.Finisher) {
        if (this.$route.query.action == "add") {
          this.$router.push({
            name: "PageEventGiftSent",
          });
        }
        this.name = resp.Finisher.name;
        this.classroom = resp.Finisher.classroomName;
        this.school = resp.Finisher.institutionName;
        this.town = resp.Finisher.town;
        this.state = resp.Finisher.state;
        this.race = resp.Finisher.race;
        this.originalRace = resp.Finisher.originalRace;
        this.gender = resp.Finisher.gender;
        this.originalGender = resp.Finisher.originalGender;
        this.moeNumber = resp.Finisher.moeNumber;
        this.email = resp.Finisher.email;
      } else {
        this.loadFinisherData();
      }
    };
    this.FinisherApi.params = {
      eventCode: this.$route.params.code,
    };
  },
  async mounted() {
    if (this.series.isCompleted) {
      await this.loadStateData()
      this.name = this.auth.User.name;
      this.classroom = this.auth.Classroom ? this.auth.Classroom.name : "";
      this.school = this.auth.Institution ? this.auth.Institution.name : "";
      this.town = this.auth.Institution ? this.auth.Institution.town : "";
      this.$api.fetch(this.FinisherApi);
    } else {
      this.exit();
    }
  },
  methods: {
    exit() {
      this.$router.push({
        name:
          this.series.type == "book" ? "PageEventABCBooks" : "PageEventLevels",
      });
    },
    okAction() {
      try {
        const name = this.name ? this.name.trim() : "";
        const classroom = this.classroom ? this.classroom.trim() : "";
        const school = this.school ? this.school.trim() : "";
        const town = this.town ? this.town.trim() : "";
        const state = this.state ? this.state.trim() : "";
        if (
          name == "" ||
          classroom == "" ||
          school == "" ||
          town == "" ||
          state == "" ||
          (this.auth.Group.type == "family" &&
            ((this.race == "other" && this.originalRace == null) ||
              (this.gender == "other" && this.originalGender == null)))
        ) {
          this.error = true;
          this.errorMessage = "Please fill in all information";
        } else {
          if (this.$route.query.action == "add") {
            this.saveFinisher();
          }

          if (this.$route.query.action == "update") {
            this.updateFinisher();
          }
        }
      }
      catch (error) {
        this.error = true;
        this.errorMessage = error;
      }
    },
    loadFinisherData() {
      this.FinisherDataApi.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/finisher/load";

      this.FinisherDataApi.callbackReset = () => {
        this.FinisherDataApi.isLoading = true;
        this.FinisherDataApi.isError = false;
      };

      this.FinisherDataApi.callbackError = (e) => {
        this.FinisherDataApi.isLoading = false;
        this.FinisherDataApi.isError = true;
        this.FinisherDataApi.error = e;
      };
      this.FinisherDataApi.callbackSuccess = (resp) => {
        this.FinisherDataApi.isLoading = false;
        if (resp) {
          this.name = resp.name;
          this.classroom = resp.classroomName;
          this.school = resp.institutionName;
          this.town = resp.town;
        }
      };
      this.$api.fetch(this.FinisherDataApi);
    },
    async loadStateData() {
      this.StateDataApi.method = "get"
      this.StateDataApi.url =
        this.$api.servers.sso +
        "/api/v1/en/data/state";

      this.StateDataApi.callbackReset = () => {
        this.StateDataApi.isLoading = true;
        this.StateDataApi.isError = false;
      };

      this.StateDataApi.callbackError = (e) => {
        this.StateDataApi.isLoading = false;
        this.StateDataApi.isError = true;
        this.StateDataApi.error = e;
      };
      this.StateDataApi.callbackSuccess = (resp) => {
        this.StateDataApi.isLoading = false;
        this.states = resp
      };
      await this.$api.fetch(this.StateDataApi);
    },
    saveFinisher() {
      this.FinisherApi.url =
        this.$api.servers.event +
        "/api/v3/" +
        this.$_getLocale() +
        "/game/event/finisher/save";

      this.FinisherApi.callbackReset = () => {
        this.FinisherApi.isLoading = true;
        this.FinisherApi.isError = false;
      };

      this.FinisherApi.callbackError = (e) => {
        this.FinisherApi.isLoading = false;
        this.FinisherApi.isError = true;
        this.FinisherApi.error = e;
      };
      this.FinisherApi.callbackSuccess = () => {
        this.FinisherApi.isLoading = false;
        if (this.auth.Player.userId != null)
          this.saveFinisherData();
        else
          this.$router.push({
            name: "PageEventGiftSent",
          });
      };

      this.FinisherApi.params = {
        name: this.name,
        classroomName: this.classroom,
        institutionName: this.school,
        town: this.town,
        state: this.state,
        eventCode: this.$route.params.code,
        institutionId: this.auth.Institution ? this.auth.Institution.id : null,
        classroomId: this.auth.Classroom ? this.auth.Classroom.id : null,
        schoolYear: this.auth.schoolYear,
        gender: this.gender,
        race: this.race,
        moeNumber: this.moeNumber,
        email: this.email,
        originalRace: this.originalRace,
        originalGender: this.originalGender,
      };
      this.$api.fetch(this.FinisherApi);
    },
    saveFinisherData() {
      this.FinisherDataApi.url =
        this.$api.servers.sso +
        "/api/v2/" +
        this.$_getLocale() +
        "/game/finisher/save";

      this.FinisherDataApi.callbackReset = () => {
        this.FinisherDataApi.isLoading = true;
        this.FinisherDataApi.isError = false;
      };

      this.FinisherDataApi.callbackError = (e) => {
        this.FinisherDataApi.isLoading = false;
        this.FinisherDataApi.isError = true;
        this.FinisherDataApi.error = e;
      };
      this.FinisherDataApi.callbackSuccess = () => {
        this.FinisherDataApi.isLoading = false;
        this.$router.push({
          name: "PageEventGiftSent",
        });
      };
      this.FinisherDataApi.params = {
        mainClassroom: this.classroom,
        mainInstitution: this.school,
        state: this.state,
        unverifiedTownName: this.town,
        gender: this.gender,
        race: this.race,
        moeNumber: this.moeNumber,
        email: this.email,
        originalRace: this.originalRace,
        originalGender: this.originalGender,
      };
      this.$api.fetch(this.FinisherDataApi);
    },
    extiError() {
      this.error = false;
    },
    updateFinisher() {
      this.FinisherApi.url =
        this.$api.servers.event +
        "/api/v3/" +
        this.$_getLocale() +
        "/game/event/finisher/edit";

      this.FinisherApi.callbackReset = () => {
        this.FinisherApi.isLoading = true;
        this.FinisherApi.isError = false;
      };

      this.FinisherApi.callbackError = (e) => {
        this.FinisherApi.isLoading = false;
        this.FinisherApi.isError = true;
        this.FinisherApi.error = e;
      };
      this.FinisherApi.callbackSuccess = () => {
        this.FinisherApi.isLoading = false;
        if (this.auth.Player.userId != null)
          this.saveFinisherData();
        else
          this.$router.push({
            name: "PageEventGiftSent",
          });
      };
      this.FinisherApi.params = {
        name: this.name,
        classroomName: this.classroom,
        institutionName: this.school,
        town: this.town,
        state: this.state,
        eventCode: this.$route.params.code,
        gender: this.gender,
        race: this.race,
        moeNumber: this.moeNumber,
        email: this.email,
        originalRace: this.originalRace,
        originalGender: this.originalGender,
      };
      this.$api.fetch(this.FinisherApi);
    },
  },
};
</script>

<style scoped>
.list-panel {
  margin-top: 20px;
  padding: 5px 0;
}

.list-card {
  padding: 0 10px;
  margin: 10px;
  background-color: #fff2e2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ticket-card {
  background-color: #fff;
  height: fit-content;
  padding: 0 10px;
}

.app-title {
  z-index: 99;
  position: fixed;
  top: 0;
  max-width: 480px !important;
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
  box-shadow: 0px 5px 2px rgba(128, 128, 128, 0.5) !important;
  border: #caad87 5px solid;
  margin: auto;
  color: #fff;
  background-color: #f7efe3;
  text-shadow: #cbb18f 3px 0px 0px, #cbb18f 2.83487px 0.981584px 0px,
    #cbb18f 2.35766px 1.85511px 0px, #cbb18f 1.62091px 2.52441px 0px,
    #cbb18f 0.705713px 2.91581px 0px, #cbb18f -0.287171px 2.98622px 0px,
    #cbb18f -1.24844px 2.72789px 0px, #cbb18f -2.07227px 2.16926px 0px,
    #cbb18f -2.66798px 1.37182px 0px, #cbb18f -2.96998px 0.42336px 0px,
    #cbb18f -2.94502px -0.571704px 0px, #cbb18f -2.59586px -1.50383px 0px,
    #cbb18f -1.96093px -2.27041px 0px, #cbb18f -1.11013px -2.78704px 0px,
    #cbb18f -0.137119px -2.99686px 0px, #cbb18f 0.850987px -2.87677px 0px,
    #cbb18f 1.74541px -2.43999px 0px, #cbb18f 2.44769px -1.73459px 0px,
    #cbb18f 2.88051px -0.838247px 0px;
}

.app-body {
  max-width: 480px;
  min-height: 100%;
  padding: 80px 0 40px 0;
  /* background-color: #f5dfc5; */
}

.screen-wrap {
  /* background-color: #f5dfc5; */
  background-color: rgba(214, 132, 49, 0.3);
}
</style>